module.exports = __webpack_public_path__ + "img/9788936456375.5de32eec.jpg";